import type { ReactNode } from 'react';
import type { TSearchHighlight } from '../../types/TSearch';
import { TProps } from './types/TProps';

export const TranscriptSearchHighlight = ({ text, highlights, currentMatchIndex }: TProps) => {
  if (!highlights?.length) {
    return text;
  }

  const orderedHighlights: TSearchHighlight[] = [...highlights].sort(
    (firstHighlight, secondHighlight) => firstHighlight.startChar - secondHighlight.startChar,
  );
  const segments: ReactNode[] = [];
  let characterCursor = 0;

  orderedHighlights.forEach((highlight) => {
    if (highlight.startChar > characterCursor) {
      segments.push(text.slice(characterCursor, highlight.startChar));
    }

    const isCurrentMatch = highlight.matchIndex === currentMatchIndex;

    segments.push(
      <mark
        key={`${highlight.startChar}-${highlight.endChar}-${highlight.matchIndex}`}
        className={`rounded-sm ${
          isCurrentMatch
            ? 'bg-[var(--color-fixed-brand)] text-[var(--color-fixed-white)]'
            : 'bg-[var(--color-accent-subtle)] text-[var(--color-fixed-brand)]'
        }`}
        data-search-current={isCurrentMatch ? 'true' : undefined}
      >
        {text.slice(highlight.startChar, highlight.endChar)}
      </mark>,
    );

    characterCursor = highlight.endChar;
  });

  if (characterCursor < text.length) {
    segments.push(text.slice(characterCursor));
  }

  return segments;
};
